import { render, staticRenderFns } from "./ProductEditDialog.vue?vue&type=template&id=470b9100&scoped=true"
import script from "./ProductEditDialog.vue?vue&type=script&lang=js"
export * from "./ProductEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductEditDialog.vue?vue&type=style&index=0&id=470b9100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b9100",
  null
  
)

export default component.exports